// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/OdooTickets_GetResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for getting a single Odoo ticket
 *
 * Response envelope:
 * {
 *   "success": true,
 *   "dados": {
 *     "ticket": { ... }
 *   },
 *   "error": null
 * }
 */
import type { OdooTickets_GetTicketRow } from './OdooTickets_GetTicketRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface OdooTickets_GetResponseDados {
ticket: OdooTickets_GetTicketRow
}

export type OdooTickets_GetResponse = ApiResponse<OdooTickets_GetResponseDados>;

registerResponseContract('OdooTickets_GetResponse', {
  ticket: {
    type: 'object',
    required: true,
    fields: {
      id:               { type: 'number',  required: true },
      name:             { type: 'string',  required: true },
      description:      { type: 'string',  required: true },
      user_description: { type: 'string',  required: true },
      description_raw:  { type: 'string',  required: true },
      stage_name:       { type: 'string',  required: true },
      status:           { type: 'string',  required: true },
      status_id:        { type: 'number',  required: true },
      created_at:       { type: 'string',  required: true },
      updated_at:       { type: 'string',  required: true },
      priority:         { type: 'string',  required: false },
      assigned_to:      { type: 'string',  required: false },
      page_uri:         { type: 'string',  required: false },
    },
  },
})
